module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive tableMain gutr"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.getListData,
      "responsive": "",
      "fields": _vm.PLField,
      "primary-key": "allModuleId",
      "per-page": _vm.pagination.perPage,
      "current-page": _vm.pagination.currentPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "allModuleId",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
          staticClass: "mr-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": row0.toggleDetails
          }
        }, [_vm._v("\n              " + _vm._s(row0.detailsShowing ? "Hide More" : "Show More") + "\n              Details\n            ")]), _vm._v(" "), (row0.item.allModuleId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Job No - ' + row0.item.JOBNO,
            "PMC_JOBID": row0.item.allModuleId,
            "PMC_JOBNO": row0.item.JOBNO,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": row0.item.clientName,
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row0.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row0.item.JOBNO,
            "PMC_JOBID": row0.item.allModuleId,
            "PMC_JOBNO": row0.item.JOBNO,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": row0.item.clientName,
            "PMC_Sline": ''
          }
        }) : _vm._e()]
      }
    }, {
      key: "row-details",
      fn: function(row4) {
        return [_c('b-card', {
          staticStyle: {
            "background": "whiteSmoke"
          }
        }, [_c('b-row', [(row4.item.transportType) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Transport Type :")]), _vm._v(" " + _vm._s(row4.item.transportType))])]) : _vm._e(), _vm._v(" "), (row4.item.SOBDate) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("SOB Date :")]), _vm._v(" " + _vm._s(row4.item.SOBDate)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.transportType) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Container Info :")]), _vm._v(" " + _vm._s(row4.item.containerInfo)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.RasiedFrom) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Rasied From :")]), _vm._v(" " + _vm._s(row4.item.RasiedFrom)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.RaisedBy) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Raised By :")]), _vm._v(" " + _vm._s(row4.item.RaisedBy)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.shipmentTypeStatus) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Shipment Type :")]), _vm._v(" " + _vm._s(row4.item.shipmentTypeStatus)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.LockStatus) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Lock Status :")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row4.item.LockStatus == 'Locked' ? 'danger' : 'success'
          }
        }, [_c('b', [_vm._v(_vm._s(row4.item.LockStatus))])]), _c('br')], 1)]) : _vm._e(), _vm._v(" "), (row4.item.BillStatus) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Bill Status :")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row4.item.BillStatus == 'Billing Completed' ?
              'success' :
              'danger'
          }
        }, [_c('b', [_vm._v(_vm._s(row4.item.BillStatus))])]), _c('br')], 1)]) : _vm._e(), _vm._v(" "), (row4.item.totExpVal) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Exp Amt :")]), _vm._v(" "), (
          row4.item.totExpVal != undefined && row4.item.totExpVal != null
        ) ? _c('b', [_vm._v(_vm._s(row4.item.totExpVal.toFixed(2)))]) : _c('b', [_vm._v("0")]), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.totExpGST) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Exp GST Amt :")]), _vm._v(" "), (
          row4.item.totExpGST != undefined && row4.item.totExpGST != null
        ) ? _c('b', [_vm._v(_vm._s(row4.item.totExpGST.toFixed(2)))]) : _c('b', [_vm._v("0")]), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.totExpGSTVal) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Exp Tot Amt :")]), _vm._v(" "), (
          row4.item.totExpGSTVal != undefined &&
          row4.item.totExpGSTVal != null
        ) ? _c('b', [_vm._v(_vm._s(row4.item.totExpGSTVal.toFixed(2)))]) : _c('b', [_vm._v("0")]), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.totInvVal) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Inv Amt :")]), _vm._v(" "), (
          row4.item.totInvVal != undefined && row4.item.totInvVal != null
        ) ? _c('b', [_vm._v(_vm._s(row4.item.totInvVal.toFixed(2)))]) : _c('b', [_vm._v("0")]), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.totInvGST) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Inv GST Amt :")]), _vm._v(" "), (
          row4.item.totInvGST != undefined && row4.item.totInvGST != null
        ) ? _c('b', [_vm._v(_vm._s(row4.item.totInvGST.toFixed(2)))]) : _c('b', [_vm._v("0")]), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.totInvGSTVal) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Inv Tot Amt :")]), _vm._v(" "), (
          row4.item.totInvGSTVal != undefined &&
          row4.item.totInvGSTVal != null
        ) ? _c('b', [_vm._v(_vm._s(row4.item.totInvGSTVal.toFixed(2)))]) : _c('b', [_vm._v("0")]), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.totPLVal) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("PL Amt :")]), _vm._v(" "), (
          row4.item.totPLVal != undefined && row4.item.totPLVal != null
        ) ? _c('b', [_vm._v(_vm._s(row4.item.totPLVal.toFixed(2)))]) : _c('b', [_vm._v("0")]), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.PICK) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Pick :")]), _vm._v(" " + _vm._s(row4.item.PICK)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.STUF) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Stuff :")]), _vm._v(" " + _vm._s(row4.item.STUF)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.HOV) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("HOV :")]), _vm._v(" " + _vm._s(row4.item.HOV)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.POR) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("POR :")]), _vm._v(" " + _vm._s(row4.item.POR)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.POL) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("POL :")]), _vm._v(" " + _vm._s(row4.item.POL)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.POD) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("POD :")]), _vm._v(" " + _vm._s(row4.item.POD)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.FPOD) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("FPOD :")]), _vm._v(" " + _vm._s(row4.item.FPOD)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.MBLNO) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("MBLNO :")]), _vm._v(" " + _vm._s(row4.item.MBLNO)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.HBLNO) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("HBLNO :")]), _vm._v(" " + _vm._s(row4.item.HBLNO)), _c('br')])]) : _vm._e(), _vm._v(" "), (row4.item.vessel_voyage) ? _c('b-col', {
          staticClass: "mb-2",
          attrs: {
            "md": "3"
          }
        }, [_c('span', [_c('b', [_vm._v("Vessel :")]), _vm._v(" " + _vm._s(row4.item.vessel_voyage))])]) : _vm._e(), _vm._v(" "), _c('b-col', {
          attrs: {
            "md": "12"
          }
        }, [(row4.item.allModuleId) ? _c('Profit-Loss', {
          attrs: {
            "PMS_fk_all_module_id": row4.item.allModuleId,
            "PMS_jb_series": row4.item.JOBNO,
            "PMS_fk_client_id": row4.item.clientName,
            "PLAccordianStatus": true,
            "PLAccordianButton": false
          }
        }) : _vm._e()], 1)], 1)], 1)]
      }
    }, {
      key: "JOBNO",
      fn: function(row1) {
        return [_c('span', [_vm._v("JOB Type : " + _vm._s(row1.item.JOBType)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("JOB NO : " + _vm._s(row1.item.JOBNO)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("JOB Date : " + _vm._s(row1.item.JOBDate)), _c('br')])]
      }
    }, {
      key: "BillStatus",
      fn: function(row2) {
        return [_c('span', [_vm._v("PL Status :\n              "), _c('b-badge', {
          attrs: {
            "variant": row2.item.totPLLabel == 'Loss' ?
              'danger' :
              row2.item.totPLLabel == 'Profit' ?
              'success' :
              'info'
          }
        }, [_c('b', [_vm._v(_vm._s(row2.item.totPLLabel))])]), _c('br')], 1)]
      }
    }, {
      key: "totExpVal",
      fn: function(row3) {
        return [_c('span', [_vm._v("PL Amt : " + _vm._s(row3.item.totPLVal)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("PL % :\n              "), (
          row3.item.totPLPercentage != undefined &&
          row3.item.totPLPercentage != null
        ) ? _c('b', [_vm._v(_vm._s(row3.item.totPLPercentage.toFixed(2)))]) : _c('b', [_vm._v("0")]), _c('br')])]
      }
    }, {
      key: "notExistInvoice",
      fn: function(row5) {
        return [(row5.item.notExistInvoice) ? _c('span', [_vm._v("Not Recd From Tally Inv : " + _vm._s(row5.item.notExistInvoice)), _c('br')]) : _vm._e(), _vm._v(" "), (row5.item.notExistOSDR) ? _c('span', [_vm._v("Not Recd From Tally OSDR : " + _vm._s(row5.item.notExistOSDR)), _c('br')]) : _vm._e(), _vm._v(" "), (row5.item.notExistOSCR) ? _c('span', [_vm._v("Not Recd From Tally OSCR : " + _vm._s(row5.item.notExistOSCR)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "clientName",
      fn: function(row4) {
        return [_c('span', [_vm._v("Client : " + _vm._s(row4.item.clientName)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Sline : " + _vm._s(row4.item.shippingLine)), _c('br')]), _vm._v(" "), _c('span', [_c('b', [_vm._v("Bill Status :")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row4.item.BillStatus == 'Billing Completed' ?
              'success' :
              'danger'
          }
        }, [_c('b', [_vm._v(_vm._s(row4.item.BillStatus))])]), _c('br')], 1), _vm._v(" "), (
          row4.item.finalBillingCompleted == '1' &&
          row4.item.assignmentCloseReason
        ) ? _c('span', {
          staticStyle: {
            "color": "green"
          },
          domProps: {
            "innerHTML": _vm._s(row4.item.assignmentCloseReason)
          }
        }, [_vm._v(_vm._s(_vm.wordWrap(row4.item.assignmentCloseReason, 24)))]) : _vm._e(), _vm._v(" "), (row4.item.allModuleId) ? _c('PlApprovalCom', {
          attrs: {
            "PL_title": 'Profit Loss Approval - ',
            "PL_JOBID": row4.item.allModuleId,
            "PL_JOBNO": row4.item.JOBNO,
            "PL_JOBDATE": row4.item.JOBDate,
            "PL_JOBTYPE": row4.item.JOBType,
            "PL_Client": row4.item.clientName,
            "PL_Sline": row4.item.shippingLine,
            "PL_pl_approved_flag": row4.item.pl_approved,
            "PL_is_pl_approved": row4.item.is_pl_approved,
            "PL_pl_approved_date": row4.item.pl_approved_date,
            "PL_pl_approved_remark": row4.item.pl_approved_remark
          }
        }) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "8",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.totalRowsCount
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-592894a8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/plTable.vue
// module id = 2657
// module chunks = 0